import { render, staticRenderFns } from "./FragranceDisplay.vue?vue&type=template&id=015d4750&scoped=true"
import script from "./FragranceDisplay.vue?vue&type=script&lang=js"
export * from "./FragranceDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d4750",
  null
  
)

export default component.exports